module.exports = __webpack_public_path__ + "img/dfod-logo-2.3bcb25c3.svg";